var map = {
	"./icon_csv.png": 3512,
	"./icon_excel.png": 9541,
	"./icon_other.png": 9570,
	"./icon_pdf.png": 6454,
	"./icon_powerPoint.png": 9377,
	"./icon_text.png": 9875,
	"./icon_word.png": 9474,
	"./icon_zip.png": 9865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4593;